

























































import { collections, firestore } from "@/configs/firebase";
import logger from "@/configs/logger";
import { Routes } from "@/router/routes";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class Settings extends Vue {
  snack = false;
  snackText = "";
  snackColor = "";

  templates: any[] = [];

  mounted() {
    this.fetchTemplates();
  }

  async fetchTemplates() {
    try {
      const snapshot = await collections.messageTemplates.get();
      this.templates = snapshot.docs.map(doc => doc.data());
    } catch (err) {
      logger("error", "template fetch error:", err);
    }
  }

  showSnack(message: string, type: "success" | "info" | "error") {
    this.snack = true;
    this.snackColor = type || "info";
    this.snackText = message;
  }

  canSave(template: any) {
    return template.name && template.subject && template.body;
  }

  async deleteTemplate(template: any) {
    if (template.isNew) {
      this.templates.shift();
    } else {
      const confirmed = window.confirm(
        "Are you sure you want to delete this template?"
      );
      if (confirmed) {
        await collections.messageTemplates.doc(template.id).delete();
        this.templates = this.templates.filter(item => item.id !== template.id);
      }
    }
  }

  async saveTemplate(template: any) {
    try {
      if (template.isNew) {
        const data: any = {
          name: template.name,
          subject: template.subject,
          body: template.body,
          created_ts: firestore.Timestamp.now()
        };
        const snapshot = await collections.messageTemplates.add(data);
        await snapshot.update({ id: snapshot.id });
        this.templates.shift();
        data.id = snapshot.id;
        this.templates = [data, ...this.templates];
      } else {
        const item = this.templates.find(item => item.id == template.id);
        if (item) {
          await collections.messageTemplates.doc(template.id).update(item);
        }
      }
      this.showSnack("Template saved", "success");
    } catch (err) {
      logger("error", "save template error:", template, err);
      this.showSnack("An error occured", "error");
    }
  }

  addBlankTemplate() {
    if (!this.templates.length || !this.templates[0].isNew) {
      this.templates = [{ isNew: true }, ...this.templates];
    }
  }
}
